/**
 * i18n configuration — Single Source of Truth for supported locales.
 * BCP 47 tags; RTL list per Unicode CLDR.
 */
export const SUPPORTED_LOCALES = [
    "en",
    "de",
    "fr",
    "es",
    "it",
    "nl",
    "pl",
    "pt",
    "zh-Hans",
    "zh-Hant",
    "ar",
    "ru",
    "ja",
    "ko",
    "hi",
    "tr",
    "vi",
    "th",
    "bn",
    // Phase 3.1 expansion (I18N-04) — all nine are Stripe checkout locales.
    "sv",
    "da",
    "nb",
    "fi",
    "cs",
    "ro",
    "hu",
    "el",
    "id",
];
export const DEFAULT_LOCALE = "en";
/** RTL languages per Unicode CLDR (complete set). */
export const RTL_LOCALES = new Set([
    "ar",
    "he",
    "fa",
    "ur",
    "ps",
    "yi",
    "dv",
]);
/**
 * Returns true if the locale is right-to-left. The fixed list decides first: textInfo's
 * answer depends on the engine's ICU data, and older ICU reports Thaana (dv) as ltr —
 * the runtime may only ADD rtl languages the list does not know, never overrule one it does.
 */
export function isRTL(locale) {
    if (RTL_LOCALES.has(locale.split("-")[0].toLowerCase()))
        return true;
    try {
        const loc = new Intl.Locale(locale);
        if (loc.textInfo?.direction)
            return loc.textInfo.direction === "rtl";
    }
    catch {
        // ignore
    }
    return false;
}
//# sourceMappingURL=i18n-config.js.map